module.exports = __webpack_public_path__ + "img/BYD_grey.215b2d26.svg";